import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';

export const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "PlatformAppBoot"*/ './lazyIndex'),
    { name: 'PlatformAppBoot' }
);

export const lazyGetOwaAuthTokenFromMetaOsHub: LazyAction<
    typeof lazyIndex.getOwaAuthTokenFromMetaOsHub,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getOwaAuthTokenFromMetaOsHub);

export const lazyGetOwaDecodedAuthTokenFromMetaOsHub: LazyAction<
    typeof lazyIndex.getOwaDecodedAuthTokenFromMetaOsHub,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getOwaDecodedAuthTokenFromMetaOsHub);

export const lazyGetAuthTokenFromMetaOsHub: LazyAction<
    typeof lazyIndex.getAuthTokenFromMetaOsHub,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAuthTokenFromMetaOsHub);

export const lazyOpenCalendarItem: LazyAction<
    typeof lazyIndex.openCalendarItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openCalendarItem);

export const lazyComposeMeeting: LazyAction<typeof lazyIndex.composeMeeting, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.composeMeeting);

export const lazyOpenProfileItem: LazyAction<typeof lazyIndex.openProfileItem, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.openProfileItem);

export const lazyOpenMailItem: LazyAction<typeof lazyIndex.openMailItem, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.openMailItem);

export const lazyComposeMail: LazyAction<typeof lazyIndex.composeMail, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.composeMail);
export const lazyReplyMail: LazyAction<typeof lazyIndex.replyMail, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.replyMail);
export const lazyReplyAllMail: LazyAction<typeof lazyIndex.replyAllMail, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.replyAllMail);
export const lazyForwardMail: LazyAction<typeof lazyIndex.forwardMail, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.forwardMail);

export const lazyExecuteDeepLink: LazyAction<typeof lazyIndex.executeDeepLink, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.executeDeepLink);

export const lazyGetContext: LazyAction<typeof lazyIndex.getContext, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getContext);

export const lazyGetConfigSetting: LazyAction<
    typeof lazyIndex.getConfigSetting,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getConfigSetting);

export const lazyCheckCalendarCapability: LazyAction<
    typeof lazyIndex.checkCalendarCapability,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.checkCalendarCapability);

export const lazyCheckMailCapability: LazyAction<
    typeof lazyIndex.checkMailCapability,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.checkMailCapability);

export const lazyCheckDialogCapability: LazyAction<
    typeof lazyIndex.checkDialogCapability,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.checkDialogCapability);

export const lazyIsDarkTheme: LazyAction<typeof lazyIndex.isDarkTheme, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.isDarkTheme);

export const lazyJoinTeamsMeeting: LazyAction<
    typeof lazyIndex.joinTeamsMeeting,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.joinTeamsMeeting);

export const lazyModalOpened: LazyAction<typeof lazyIndex.modalOpened, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.modalOpened);

export const lazySubmitTask: LazyAction<typeof lazyIndex.submitTask, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.submitTask);

export const lazyNotifySuccess: LazyAction<typeof lazyIndex.notifySuccess, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.notifySuccess);

export const lazyNotifyFailure: LazyAction<typeof lazyIndex.notifyFailure, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.notifyFailure);
export const lazyNotifyOtherFailure: LazyAction<
    typeof lazyIndex.notifyOtherFailure,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.notifyOtherFailure);

export const lazyNotifyAppLoaded: LazyAction<typeof lazyIndex.notifyAppLoaded, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.notifyAppLoaded);

export const lazyRegisterIsDarkThemeOnChangeHandler: LazyAction<
    typeof lazyIndex.registerIsDarkThemeOnChangeHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.registerIsDarkThemeOnChangeHandler);

export const lazyInitializeMetaOsCapabilities: LazyAction<
    typeof lazyIndex.initializeMetaOsCapabilities,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeMetaOsCapabilities);

export const lazyHandleThemeChange: LazyAction<
    typeof lazyIndex.handleThemeChange,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.handleThemeChange);

export const lazyIsMetaOsAppSdkInitialized: LazyAction<
    typeof lazyIndex.isMetaOsAppSdkInitialized,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isMetaOsAppSdkInitialized);

export const lazyInitializeMetaOsApp: LazyAction<
    typeof lazyIndex.initializeMetaOSApp,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeMetaOSApp);

export const lazyInitializeMetaOsAppSdk: LazyAction<
    typeof lazyIndex.initializeMetaOsAppSdk,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeMetaOsAppSdk);

export const lazyRegisterOnLoadHandler: LazyAction<
    typeof lazyIndex.registerOnLoadHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.registerOnLoadHandler);
export const lazyRegisterOnCachedLoadCompleted: LazyAction<
    typeof lazyIndex.registerOnCachedLoadCompleted,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.registerOnCachedLoadCompleted);
export const lazyRegisterBeforeUnloadHandler: LazyAction<
    typeof lazyIndex.registerBeforeUnloadHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.registerBeforeUnloadHandler);

export const lazyRemoveAppCachingQueryParam: LazyAction<
    typeof lazyIndex.removeAppCachingQueryParam,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeAppCachingQueryParam);

export const lazyStartCall: LazyAction<typeof lazyIndex.startCall, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.startCall);
export const lazyOpenChat: LazyAction<typeof lazyIndex.openChat, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.openChat);
export const lazyOpenGroupChat: LazyAction<typeof lazyIndex.openGroupChat, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.openGroupChat);
export const lazyOpenDialog: LazyAction<typeof lazyIndex.open, typeof lazyModule> = new LazyAction(
    lazyModule,
    m => m.open
);
export const lazyPreInitOwaAccountSourceListStore: LazyAction<
    typeof lazyIndex.preInitOwaAccountSourceListStore,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.preInitOwaAccountSourceListStore);
export const lazyGetAccountServiceConfig: LazyAction<
    typeof lazyIndex.getAccountServiceConfig,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAccountServiceConfig);
export const lazyNavigateToApp: LazyAction<typeof lazyIndex.navigateToApp, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.navigateToApp);
export const lazyNavigateToDefaultPage: LazyAction<
    typeof lazyIndex.navigateToDefaultPage,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.navigateToDefaultPage);
export const lazyJoinMeeting: LazyAction<typeof lazyIndex.joinMeeting, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.joinMeeting);
export const lazyGetCachedContext: LazyAction<
    typeof lazyIndex.getCachedContext,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getCachedContext);
export const lazyIsNAAChannelRecommended: LazyAction<
    typeof lazyIndex.isNAAChannelRecommended,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isNAAChannelRecommended);
export const lazyIsDeeplyNestedAppAuthSupported: LazyAction<
    typeof lazyIndex.isDeeplyNestedAppAuthSupported,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isDeeplyNestedAppAuthSupported);
export const lazyGetParentOrigin: LazyAction<typeof lazyIndex.getParentOrigin, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getParentOrigin);
export const lazyAddNAATrustedOrigins: LazyAction<
    typeof lazyIndex.addNAATrustedOrigins,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addNAATrustedOrigins);
export const lazyOpenStageView: LazyAction<typeof lazyIndex.openStageView, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.openStageView);
export const lazyCloseStageView: LazyAction<typeof lazyIndex.closeStageView, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.closeStageView);
export const lazyCheckStageViewCapability: LazyAction<
    typeof lazyIndex.checkStageViewCapability,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.checkStageViewCapability);

export const lazyRemoveTab: LazyAction<typeof lazyIndex.removeTab, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.removeTab);

export const lazyRenameTab: LazyAction<typeof lazyIndex.renameTab, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.renameTab);

export const lazyReconfigureTab: LazyAction<typeof lazyIndex.reconfigureTab, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.reconfigureTab);
export const lazyOpenCreateTabFlyout: LazyAction<
    typeof lazyIndex.openCreateTabFlyout,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openCreateTabFlyout);

export const lazyHandleHostSearch: LazyAction<
    typeof lazyIndex.handleHostSearch,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.handleHostSearch);

export const lazyOpenFilePreview: LazyAction<typeof lazyIndex.openFilePreview, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.openFilePreview);
